import { BooleanFilter, OptionFilter, StringFilter } from '@common/searchFilter/searchFilter.models';
import { IMasterScheduleOption } from '@masterSchedule/masterSchedule.models';

export interface ILoadingRemovalCertSearch {
  id: number;
  certificateNo?: string;
  status?: EPermitToLoadStatus;
  type?: EPermitToLoadType;
  riskCategory?: string;
  projectMasterSchedule?: IMasterScheduleOption;
  designPackage?: string;
  location?: string;
  elementOfWorks?: string;
  removalCertRequired: boolean;
  twc?: string;
  srp?: string;
  actioner?: string;
  isRemovalCert: boolean;
  isLoadingCertCompleted: boolean;
  isRemovalCertCompleted: boolean;
  loadCertId?: number;
  headerCertNo?: string;
  hasRemovalCert?: boolean;
}

export interface ILoadingRemovalCertSearchFilter {
  certificateNo: StringFilter;
  t1RefNo: StringFilter;
  designPackage: StringFilter;
  location: StringFilter;
  elementOfWorks: StringFilter;
  action: OptionFilter;
  riskCategory: OptionFilter;
  removalRequired: BooleanFilter;
  twc: OptionFilter;
  srp: OptionFilter;
}
export const loadingRemovalCertSearchKeys = {
  CERTIFICATE_NO: 'certificateNo',
  LOCATION: 'location',
  ELEMENT_OF_WORKS: 'elementOfWorks',
  ACTIONER: 'actioner',
  IS_REMOVAL_CERT: 'isRemovalCert',
  REMOVAL_REQUIRED: 'removalCertRequired',
  T1_REF_NO: 'refNo',
  DESIGN_PACKAGE: 'designPackage',
  RISK_CATEGORY: 'riskCategory',
  TWC: 'twc',
  TWCM: 'twcm',
  SRP: 'srp',
};

export enum loadingRemovalCertSearchColumnKeys {
  CERTIFICATE_NO = 'certificateNo',
  RISK_CATEGORY = 'projectMasterSchedule.riskCategory',
  T1_REF_NO = 'projectMasterSchedule.refNo',
  DESIGN_PACKAGE = 'projectMasterSchedule.designPackage',
  LOCATION = 'location',
  ELEMENT_OF_WORKS = 'elementofWorks',
  REMOVAL_REQUIRED = 'removalCertRequired',
  TWC = 'twc',
  SRP = 'srp',
  ACTIONER = 'actioner',
  STATUS = 'status',
}

export enum EPermitToLoadStatus {
  INITIAL = 'IN',
  WAITING_FOR_TWC = 'WT',
  WAITING_FOR_DESIGNER = 'WD',
  WAITING_FOR_ICE = 'WI',
  WAITING_FOR_PM = 'WP',
  WAITING_FOR_ENG_REMOVAL = 'RE',
  WAITING_FOR_TWC_REMOVAL = 'RT',
  WAITING_FOR_ICE_REMOVAL = 'RI',
  COMPLETED = 'CD',
  TWC_REJECTED = 'RJ',
  TWC_REMOVAL_REJECTED = 'RR',
  CANCEL = 'CL',
}

export enum EPermitToLoadType {
  LOAD = 'Load',
  UNLOAD = 'Unload',
}

export enum ELoadingRemovalCertActionType {
  SRP = 'SRP',
  TWC = 'TWC',
  DESIGNER = 'Designer',
  ICE = 'ICE',
  PM = 'PM',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
}
